import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const PollHeadlineToolTip = (props) => (
  <div>
    The name of the break.
    Featured on site homepage, top of the break and the landing page of sponsored breaks.
    Editorial breaks prepopulate headline from the “Break title” in the General break section.
    <br/>
    <img src={makeToolTipUrl('poll/1.CMS-Poll-Headline.png')} width="100%"/>
  </div>
);

export const PollIntroCopyToolTip = (props) => (
  <div>
    (this field does not exist currently in CMS or front end) Copy introducing the poll.
  </div>
);


export const PollAnswerButtonBkgdToolTip = (props) => (
  <div>
    Border color of the poll answer buttons. Defaults to #4C3371.
  </div>
);

export const PollAnswerButtonTextToolTip = (props) => (
  <div>
    Text color of the poll answer buttons. Defaults to #fff (white).
  </div>
);

export const PollQuestionToolTip = (props) => (
  <div>
    A question to prompt the user to respond.
    <br/>
    <img src={makeToolTipUrl('poll/4.CMS-Poll-Question1.png')} width="100%"/>
  </div>
);

export const PollQuestionImageToolTip = (props) => (
  <div>
    Image that relates the the question or results.
    <br/>
    <img src={makeToolTipUrl('poll/5.CMS-Poll-Question1-image.png')} width="100%"/>
  </div>
);

export const PollAnswerToolTip = (props) => (
  <div>
    Text or image option to answering the question, that appears as a button under the question.
    <br/>
    <img src={makeToolTipUrl('poll/6.CMS-Poll-Answer2.png')} width="100%"/>
  </div>
);

export const PollEditButtonColorsToolTip = (props) => (
  <div>
    If yes, color on the poll answer buttons can be individually customized.
    <br/>
    <img src={makeToolTipUrl('poll/7.CMS-Poll-Answer2-button-bkgd-color.png')} width="100%"/>
  </div>
);

export const PollAnswerButtonBkgdColorToolTip = (props) => (
  <div>
    Color on this poll answer button only.
    <br/>
    <img src={makeToolTipUrl('poll/7.CMS-Poll-Answer2-button-bkgd-color.png')} width="100%"/>
  </div>
);

export const PollAnswerButtonTextColorToolTip = (props) => (
  <div>
    Color of text on this poll answer button only.
    <br/>
    <img src={makeToolTipUrl('poll/8.CMS-Poll-Answer2-button-text.png')} width="100%"/>
  </div>
);

export const PollAnswerButtonBgHoverToolTip = (props) => (
  <div>
    Border color of the poll answer buttons on hover. Defaults to #4C3371.
  </div>
);

export const NextQuestionButtonBgToolTip = (props) => (
  <div>
    Background color of the "Next Question" button. Defaults to #fff (white).
  </div>
);

export const NextQuestionButtonTextToolTip = (props) => (
  <div>
    Text color of the "Next Question" button. Defaults to #000 (black).
  </div>
);

export const NextQuestionButtonBgHoverToolTip = (props) => (
  <div>
    Background color of the "Next Question" button on hover. Defaults to #704FA0 (purple).
  </div>
);

export const DropdownButtonBgToolTip = (props) => (
  <div>
    Default background color for all CTA/dropdown buttons. Can be customized per button. Defaults to #4C3371.
  </div>
);

export const DropdownButtonTextToolTip = (props) => (
  <div>
    Default text color for all CTA/dropdown buttons. Can be customized per button. Defaults to #fff (white).
  </div>
);

export const DropdownButtonBgHoverToolTip = (props) => (
  <div>
    Default background color for all CTA/dropdown buttons on hover. Can be customized per button. Defaults to #4C3371.
  </div>
);

export const PollQuestionResultTextToolTip = (props) => (
  <div>
    Optional field for result copy.
    <br/>
    <img src={makeToolTipUrl('poll/9.CMS-Poll-Q1-result-text.png')} width="100%"/>
  </div>
);

export const PollQuestionResultImageToolTip = (props) => (
  <div>
    Optional field for result image. Typically used for product image in sponsored breaks.
    <br/>
    <img src={makeToolTipUrl('poll/10.CMS-Poll-Q1-result-image.png')} width="100%"/>
  </div>
);

export const PollChangeSocialImageToolTip = (props) => (
  <div>
    If yes, you can override the default “Facebook and social image.
    <br/>
    <img src={makeToolTipUrl('11.CMS-Poll-different-image-social-sharing.png')} width="100%"/>
  </div>
);

export const PollQuestionSocialImageToolTip = (props) => (
  <div>
    Image that will appear when sharing a break on Facebook and Pinterest for this question.
  </div>
);

export const PollQuestionResultGraphColorToolTip = (props) => (
  <div>
    If yes, color on the result graph colors can be customized.
    <br/>
    <img src={makeToolTipUrl('poll/12.CMS-Poll-edit-result-graph-colors.png')} width="100%"/>
  </div>
);

export const PollResultGraphSuccessToolTip = (props) => (
  <div>
     Pre-populated with the “Progress Bar Success Bkgd Color” in Sponsored campaigns, but color can be customized for the item the reader selects.
     <br/>
    <img src={makeToolTipUrl('poll/13.CMS-Poll-success-bkgd-color.png')} width="100%"/>
  </div>
);

export const PollResultGraphFailToolTip = (props) => (
  <div>
     Pre-populated with the “Progress Bar Fail Bkgd Color” in Sponsored campaigns, but color can be customized for the item the reader selects.
     <br/>
    <img src={makeToolTipUrl('poll/14.CMS-Poll-fail-bkgd-color.png')} width="100%"/>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/poll-tool-tips.jsx